module.exports = __webpack_public_path__ + "static/jon-a03ec0a754cb9b94a4574391434ca120.jpg";